export const SITE_NAME = 'Apus Agency';

export const BREAKPOINT_LG = 1440;
export const BREAKPOINT_MD = 1024;
export const BREAKPOINT_SM = 767;
export const BREAKPOINT_XSM = 375;
export const MOCKUP_WIDTH_SM = 640;

export const FONT_SIZE_TEXT = 24;
export const FONT_SIZE_MEDIUM = 36;
export const FONT_SIZE_BIG = 56;
export const FONT_SIZE_MEDIUM_LARGE = 76;
export const FONT_SIZE_LARGE = 80;

export const ITEM_TYPES = {
  case: 'case',
  news: 'news',
};

export const PREVIEW_TYPES = {
  case: 'case',
  page: 'page',
};

export const FONT_FAMILY_MAIN = 'Formular';

export const TRANSITION_DURATION = '0.35s';

export const TRANSITION_FUNCTION = 'ease-out';

export const EMAIL_CONTACT = 'hi@apus.ag';

export const MENU_ITEMS = [
  {
    name: 'Агентство',
    path: '/ru/about',
  },
  {
    name: 'Наш подход',
    path: '/ru/approach',
  },
  {
    name: 'Branding',
    path: '/ru/cases?category=branding',
  },
  {
    name: 'Digital',
    path: '/ru/cases?category=digital',
  },
  {
    name: 'Новости',
    path: '/ru/news',
  },
  {
    name: 'Вакансии',
    path: '/ru/jobs',
  },
  {
    name: 'Начать проект',
    path: '/ru/brief',
  },
  {
    name: 'Контакты',
    path: '/ru/contacts',
  },
];

export const LARGE_COL_WIDTH = 398;

export const CONTAINER_WIDTH = 1368;

export const CONTAINER_WIDTH_MD = 972;

export const CONTAINER_WIDTH_SM = 592;

export const INPUT_HEIGHT = 72;



// WEBPACK FOOTER //
// ./src/constants/index.js